import AddAgreement from '../agreements/AddAgreement';
import {
  agreementFilterFields,
  agreementSelectLabel,
} from '../agreements/constants';
import { AgreementLink } from '../agreements/Link';
import {
  TeamAssociationFilterFields,
  TeamAssociationLabel,
} from '../approval/constants';
import AddAttachment from '../attachments/AddAttachment';
import {
  attachmentAssociationFilterFields,
  AttachmentAssociationLabel,
} from '../attachments/constants';
import AddBrand from '../brands/AddBrand';
import { brandFilterFields, brandSelectLabel } from '../brands/constants';
import { BrandLink } from '../brands/Link';
import {
  campaignFilterFields,
  campaignSelectLabel,
} from '../campaigns/constants';
import { CampaignLink } from '../campaigns/Link';
import {
  commercialPackageFilterFields,
  commercialPackageSelectLabel,
} from '../commercial-packages/constants';
import { CommercialPackageLabel } from '../commercial-packages/Label';
import AddContact from '../contacts/AddContact';
import { contactFilterFields, contactSelectLabel } from '../contacts/constants';
import { ContactLink } from '../contacts/Link';
import {
  merchantFilterFields,
  merchantSelectLabel,
} from '../merchants/constants';
import { MerchantLink } from '../merchants/Link';
import MerchantAssociationInactiveView from '../merchants/MerchantAssociationInactiveView';
import { getUniqueMerchants } from '../merchants/utils';
import {
  opportunityFilterFields,
  opportunitySelectLabel,
} from '../opportunities/constants';
import { OpportunityLink } from '../opportunities/Link';
import { productFilterFields, productLabel } from '../products/constants';
import { quoteFilterFields, quoteSelectLabel } from '../quotes/constants';
import { QuoteLink } from '../quotes/Link';
import api from '../REST/api';
import { userFilterFields, userSelectLabel } from '../users/constants';
import { UserLink } from '../users/Link';
import EmptyComponent from '../utils/empty-component';
import {
  paymentTermsFilterFields,
  paymentTermsSelectLabel,
} from './payment-terms/constants';
import { PaymentTermsLabel } from './payment-terms/Label';
import {
  targetSuppliersFilterFields,
  targetSuppliersSelectLabel,
} from './target-suppliers/constants';
import TargetSuppliersLabel from './target-suppliers/Label';
import { filterLockedSuppliers } from './target-suppliers/utils';

function removeDeprecatedItems(apiMethod) {
  return (...props) =>
    apiMethod(...props).then(objects => objects.filter(obj => !obj.deprecated));
}

const getMappings = name => ({
  brand: {
    label: brandSelectLabel,
    load: api.getBrands,
    fields: brandFilterFields,
    view: BrandLink,
    add: AddBrand,
    async: true,
  },
  campaign: {
    label: campaignSelectLabel,
    load: api.getCampaignsBasic,
    fields: campaignFilterFields,
    view: CampaignLink,
  },
  contact: {
    label: contactSelectLabel,
    load: api.getContacts,
    fields: contactFilterFields,
    view: ContactLink,
    add: AddContact,
  },
  commercialPackage: {
    label: commercialPackageSelectLabel,
    load: removeDeprecatedItems(api.getCommercialPackages),
    fields: commercialPackageFilterFields,
    view: CommercialPackageLabel,
  },
  opportunity: {
    label: opportunitySelectLabel,
    load: api.getOpportunities,
    fields: opportunityFilterFields,
    view: OpportunityLink,
    async: true,
  },
  quote: {
    label: quoteSelectLabel,
    load: api.getQuotes,
    fields: quoteFilterFields,
    view: QuoteLink,
    async: true,
  },
  user: {
    label: userSelectLabel,
    load: api.getUsers,
    fields: userFilterFields,
    view: UserLink,
  },
  product: {
    label: productLabel,
    load: removeDeprecatedItems(api.getProducts),
    fields: productFilterFields,
    view: ({ model }) => productLabel(model),
  },
  agreement: {
    label: agreementSelectLabel,
    load: api.getAgreements,
    fields: agreementFilterFields,
    view: AgreementLink,
    add: AddAgreement,
  },
  // This is used by SKU since it needs to pass the
  // the merchant name and does not need a link.
  merchant: {
    label: merchantSelectLabel,
    // name has been passed to distinguish between merchantName and merchantIds since it is different for Campaigns and SKU
    load: () => getUniqueMerchants(name),
    fields: merchantFilterFields,
    view: MerchantAssociationInactiveView,
  },
  allZmsamMerchant: {
    label: merchantSelectLabel,
    load: api.getZMSAMMerchants,
    fields: merchantFilterFields,
    view: MerchantLink,
    async: true,
  },
  zmsamMerchant: {
    label: merchantSelectLabel,
    load: api.getActiveZMSAMMerchants,
    fields: merchantFilterFields,
    view: MerchantLink,
    async: true,
  },
  attachment: {
    label: AttachmentAssociationLabel,
    load: api.getAttachments,
    fields: attachmentAssociationFilterFields,
    view: AttachmentAssociationLabel,
    add: AddAttachment,
  },
  approvalTeam: {
    label: TeamAssociationLabel,
    load: api.getTeams,
    fields: TeamAssociationFilterFields,
    view: EmptyComponent, // Approval Team association is always used in the active view
  },
  paymentTerms: {
    label: paymentTermsSelectLabel,
    load: () => api.getPaymentTerms({ search: { isAvailableToUsers: true } }),
    fields: paymentTermsFilterFields,
    view: PaymentTermsLabel,
  },
  targetSuppliers: {
    label: targetSuppliersSelectLabel,
    load: filterLockedSuppliers(api.getTargetSuppliers),
    fields: targetSuppliersFilterFields,
    view: TargetSuppliersLabel,
    async: true,
  },
});

export default getMappings;
